export const createFieldHtmlId = (formId: number, id: string | number) => {
  return `field_${formId}_${id}`
}
